import React from 'react';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import styles from './status-badge.module.scss';
import {colorFamily, EnumName, labelId} from './labels';

interface StatusBadgeProps {
  kind: EnumName;
  value: string;
}

export const useEnumLabel = () => {
  const intl = useIntl();
  return (kind: EnumName, value: string) => {
    const id = labelId(kind, value);
    return id ? intl.formatMessage({id}) : value;
  };
};

const StatusBadge = ({kind, value}: StatusBadgeProps) => {
  const label = useEnumLabel();
  return (
    <span className={classNames(styles.badge, styles[colorFamily(kind, value)])} data-family={colorFamily(kind, value)}>
      {label(kind, value)}
    </span>
  );
};

export default StatusBadge;
